module.exports = __webpack_public_path__ + "mp.68debd8c2998eea6bc74.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/flag-icon-css/flags/1x1/mp.svg
// module id = ../../../../flag-icon-css/flags/1x1/mp.svg
// module chunks = styles